/**
 GS1_128码解析类
 010061414199999610batch(FNC1)30100

 //协议编码
 "30":{
 "title": "VAR . COUNT",
 "digit": 8,//长度或最大长度
 "mapping":"amount",//盘谷特殊用法，用于映射业务字段属性。
 "fnc1_required": true//是否是变长（简单判读可使用这个）.变长情况下，可以只认变长标识符，不管最大长度digit
 }


 */
import protocol_gs1 from './protocol_gs1.json'

/**
 * Spu属性选择类
 */
class ParseGs1 {
  constructor() {
    //接口协议
    this.protocol = null
    //边长标示符
    // this.END_AI_VARIED=String.fromCharCode(29)
    this.END_AI_VARIED = 'ñ'
    //转换格式-日期：YYMM00   => YYYY-MM-01  （如果DD=00，则设置01，大于00，则取实际值）
    this.GS1_FORMAT_DATE_BEGIN = 'DATE_BEGIN'
    //转换格式-日期：YYMM00   => YYYY-MM-31  （如果DD=00，YYYY-MM月份的最后1天。可能值：28,29,30,31，大于00，则取实际值)
    this.GS1_FORMAT_DATE_END = 'DATE_END'
    this.init()
  }

  /*
   * 根据协议初始化解析
   * @param protocol
   *
   */
  init(protocol) {
    this.protocol = protocol || protocol_gs1
  }

  /**
   * 根据扫描的字符间解析对象
   * @param value 010061414199999610batch(FNC1)30100
   *
   * @return Map<code,"">
   *   {
   *      01:"00614141999996",
   *      10:"batch",
   *      30:"100"
   *   }
   */
  decode(value) {
    let builder = {}

    while (value.length > 0 && !builder.error) {
      // 预处理 value，兼容不同扫码枪识别的 GS1 码。例如：0106935758203622ñ11210603ñ102004417ñ210449
      const _value = this.convertValue(value)
      value = _value.substr(this.variedValue(_value, builder))
    }

    return builder
  }

  /**
   * 根据协议转化key值
   * @param  val {
   *      01:"00614141999996",
   *      10:"batch",
   *      30:"100"
   *   }
   * @param {boolean} [isValueOfObject=false] 结果是否是对象（透传给方法 initFormatConvert）
   *
   * @return
   *   {
   *      gtin:"00614141999996",
   *      batchNumber:"batch",
   *      amount:"100"
   *   }
   */
  variedKey(val, isValueOfObject = false) {
    let builder = {}
    this.initFormatConvert(val, isValueOfObject)

    for (let key in val) {
      if (this.protocol[key] && this.protocol[key].mapping) {
        builder[this.protocol[key].mapping] = val[key]
      } else {
        builder[key] = val[key]
      }
    }

    return builder
  }
  /**
   *  盘谷业务数据格式转换映射表 key gs1编码。value;转换格式 .初始化值。目前仅有日期需要处理
   * @param {*} val 待处理的数据
   * @param {boolean} [isValueOfObject=false] 结果是否是对象（透传给方法 FormatConvertOrderGS1Map）
   */
  initFormatConvert(val, isValueOfObject = false) {
    this.FormatConvertOrderGS1Map(val, '11', this.GS1_FORMAT_DATE_BEGIN, isValueOfObject) //PROD_DATE
    this.FormatConvertOrderGS1Map(val, '12', this.GS1_FORMAT_DATE_END, isValueOfObject)
    this.FormatConvertOrderGS1Map(val, '13', this.GS1_FORMAT_DATE_BEGIN, isValueOfObject)
    this.FormatConvertOrderGS1Map(val, '15', this.GS1_FORMAT_DATE_END, isValueOfObject)
    this.FormatConvertOrderGS1Map(val, '17', this.GS1_FORMAT_DATE_END, isValueOfObject)
  }
  //  gs1 key 与 定义 mapping 映射
  getKeyMapping(key) {
    if (!key) return null
    if (this.protocol[key] && this.protocol[key].mapping) {
      return this.protocol[key].mapping
    }
    return key
  }

  //转化日期格式
  FormatConvertOrderGS1Map(obj, key, dateType, isValueOfObject) {
    let newDate = ''
    let nowDate = new Date()
    let val = obj[key]
    if (!val) {
      return
    }

    if (val.length == 6) {
      if (val.substring(4, 6) == '00') {
        val = val.substring(0, 4) + '01'
        if (dateType == this.GS1_FORMAT_DATE_BEGIN) {
          newDate = this.formatStringYYYYMMddToYYYY_MM_dd(
            nowDate.getFullYear().toString().substring(0, 2) + val
          )
        } else if (dateType == this.GS1_FORMAT_DATE_END) {
          let value = (nowDate.getFullYear().toString().substring(0, 2) + val).substring(0, 6)
          newDate = this.formatStringYYYYMMddToYYYY_MM_dd(value)
          newDate =
            newDate + '-' + new Date(value.substring(0, 4), value.substring(4, 6), 0).getDate()
        }
      } else {
        newDate = this.formatStringYYYYMMddToYYYY_MM_dd(
          nowDate.getFullYear().toString().substring(0, 2) + val
        )
      }
    }

    obj[key] = isValueOfObject ? { date: newDate, value: val } : newDate
  }
  //把formatStringYYYYMMdd转化成YYYY_MM_dd
  formatStringYYYYMMddToYYYY_MM_dd(value) {
    if (value.length == 8) {
      return value.substring(0, 4) + '-' + value.substring(4, 6) + '-' + value.substring(6, 8)
    } else if (value.length == 6) {
      return value.substring(0, 4) + '-' + value.substring(4, 6)
    } else {
      return value
    }
  }
  /**
   * 预处理函数 variedValue 的第一个参数 value 的值
   * 解决无法识别的 GS1 码，例如：0106935758203622ñ11210603ñ102004417ñ210449
   * value 的值首位字符不能是 ñ
   */
  convertValue(value) {
    const index = value.indexOf('ñ')
    if (index === 0) return value.slice(1) // 去掉下标为 0 的 ñ
    return value
  }
  /**
   * *根据value转化第一个对应的obj
   *
   * @param value builder
   *
   * @return 解析出来的字符串在value的截止位置
   */
  variedValue(value, builder) {
    let i = 0
    let ai = ''
    let protocolObj = null
    let infoLength = 0

    //解析出AI值去匹配
    while (!protocolObj && i < value.length) {
      ++i
      ai = value.slice(0, i)
      protocolObj = this.protocol[ai]
    }

    if (protocolObj) {
      //判断是否变长
      if (!protocolObj.fnc1_required) {
        infoLength = protocolObj.digit
        builder[ai] = value.substr(i, infoLength)
      } else {
        //判断标示符位置，没有标识符就到最后
        if (value.indexOf(this.END_AI_VARIED) > 0) {
          infoLength = value.indexOf(this.END_AI_VARIED) - i
        } else {
          infoLength = value.length - i
        }
        //解析出的值长度小于0或者大于最长变长都应判断为条码错误
        if (infoLength <= 0 || infoLength > protocolObj.digit) {
          builder.error = '不能正确解析出条码对应信息，请检查条码是否正确'
        } else {
          builder[ai] = value.substr(i, infoLength)
          //如果有截止符，那么需要将截止符包含
          if (value.indexOf(this.END_AI_VARIED) > 0) {
            infoLength += 1
          }
        }
      }
    } else {
      builder.error = '未能找到条码对应的解析字段，请检查条码是否正确'
    }
    return i + infoLength
  }
}

export default ParseGs1
